import { useOrgContext } from '@/org/contexts/OrgContext'
import { useRolesSubscription } from '@gql'
import { RoleLinksView, RoleLinksViewProps } from '@rolebase/graph'
import { extractRoleLinks } from '@rolebase/shared/model/roleLinks'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = Omit<RoleLinksViewProps, 'links' | 'emptyLabel'>

// Links view (#107): the roles' texts are not in the org chart data, they come
// from the roles subscription. Reading the "#" mentions from them gives the web
export default function RoleLinksGraph(props: Props) {
  const { t } = useTranslation()
  const { orgId, orgData } = useOrgContext()
  const { data } = useRolesSubscription({
    skip: !orgId,
    variables: { orgId: orgId!, active: true },
  })
  const links = useMemo(
    () => (orgData ? extractRoleLinks(orgData, data?.role ?? []) : []),
    [orgData, data?.role]
  )

  return (
    <RoleLinksView
      {...props}
      links={links}
      emptyLabel={t('CirclesPage.roleLinksEmpty')}
    />
  )
}
